import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  fetchFPlusIntegrationPackages(
    { state },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.fetchFPlusIntegrationPackages
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  createFPlusIntegrationPackage({ state }, { packageCreateData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.createFPlusIntegrationPackage
        }`,
        packageCreateData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  fetchFPlusIntegrationPkgDetails({ state }, { packageCode }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.fetchFPlusIntegrationPkgDetails
        }/${packageCode}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveFPlusIntegrationPackage({ state }, { packageData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.saveFPlusIntegrationPackage
        }`,
        packageData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchFPlusCustomerDetails({ state }, packageCode) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.customerDetails
        }${packageCode}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getFraudReportIntegrationData(state, orderId) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.fraudPlusIntegration.getFraudReportIntegrationData
    }?orderId=${orderId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchFraudXIntegrationPDF(state, payload) {
    let url = `${appConfig.apiEndPoint}${
      endpoint.fraudPlusIntegration.fetchFraudXIntegrationPDF
    }?orderid=${payload.orderId}&section=${payload.section}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  saveFraudReportIntegrationStatus(
    { state },
    { CommentsDescription, StatusDescription, Status, riskindicatorid } = {}
  ) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.saveFraudReportIntegrationStatus
        }`,
        { CommentsDescription, StatusDescription, Status, riskindicatorid },
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveFraudReportIntegrationRemarks({ state }, { comments, orderID } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusIntegration.saveFraudReportIntegrationRemarks
        }?description=${comments}&orderid=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  toggleFPlusPackageStatus({ state }, packageData = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusIntegration.toggleStatus}`,
        packageData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchARSIntegrationSortData(state, sortData) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusIntegration.fetchARSIntegrationSortData}/${sortData.orderId}/${sortData.sortBy}/${sortData.sortType}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${
      store.state.fPlusIntegration.fPlusIntegrationToken
    }`,
  }
}
